"use client";
import Link from "next/link";
import { useState } from "react";

const SERVICE_OPTIONS = [
  "High-End Landing Page",
  "Multi-Page Website",
  "E-Commerce Store",
  "UI/UX App Design",
  "UX Audit & Optimization",
  "Other / Custom Project",
] as const;

const Footer = ({ ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [service, setService] = useState("");
  const [message, setMessage] = useState("");
  const [opened, setOpened] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const subject = `[Portfolio] ${service} — ${name}`;
    const body = [
      `Name: ${name}`,
      `Email: ${email}`,
      `Service: ${service}`,
      "",
      "Message:",
      message,
    ].join("\n");
    const mailto = `mailto:muhammadhilmanhumaini@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setOpened(true);
    window.location.href = mailto;
  };

  const inputClass =
    "w-full bg-transparent border-b border-neutral-400 focus:border-neutral-800 outline-none py-2 text-sm text-neutral-800 placeholder:text-neutral-500 transition-colors";

  return (
    <section className='relative bg-[#c8c9c0] text-neutral-600 font-mono' {...props}>
      <div className='container mx-auto px-5 md:px-0 py-6'>
        <div className='relative border border-neutral-400'>
          <span className='absolute -left-2 -top-3 text-2xl'>+</span>
          <span className='absolute -right-2 -top-3 text-2xl'>+</span>
          <div className='grid md:grid-cols-[180px_1fr]'>
            <div className='px-4 pt-10 md:pt-16 pb-4 text-sm whitespace-nowrap'>Ready To Start</div>
            <div className='md:border-l border-neutral-400'>
              <div className='flex flex-col sm:flex-row justify-between gap-8 border-b border-neutral-400 px-4 md:px-6 py-10 md:py-14'>
                <div>
                  <h2 className='text-5xl md:text-7xl font-bold uppercase leading-none text-neutral-800'>
                    Get In
                    <br /> Touch
                  </h2>
                  <p className='mt-4 text-sm max-w-sm leading-relaxed'>
                    Whether you have questions or just want to explore options, we&apos;re here.
                  </p>
                </div>
                <nav className='flex sm:flex-col gap-2 sm:gap-1 text-end text-black font-light sm:pt-1'>
                  <Link href='/' className='hover:text-neutral-700 transition-colors'>
                    Home
                  </Link>
                  <Link href='/portofolio#about' className='hover:text-neutral-700 transition-colors'>
                    About
                  </Link>
                  <Link href='/portofolio' className='hover:text-neutral-700 transition-colors'>
                    Portfolio
                  </Link>
                  <Link href='mailto:muhammadhilmanhumaini@gmail.com' className='hover:text-neutral-700 transition-colors'>
                    Contact
                  </Link>
                </nav>
              </div>
              <form onSubmit={handleSubmit} className='px-4 md:px-6 py-6 flex flex-col gap-5'>
                <div className='grid sm:grid-cols-3 gap-5'>
                  <label className='flex flex-col gap-1.5'>
                    <span className='text-[10px] uppercase tracking-widest'>Name</span>
                    <input
                      type='text'
                      required
                      minLength={2}
                      maxLength={80}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder='Your name'
                      className={inputClass}
                    />
                  </label>
                  <label className='flex flex-col gap-1.5'>
                    <span className='text-[10px] uppercase tracking-widest'>Email</span>
                    <input
                      type='email'
                      required
                      maxLength={120}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder='you@example.com'
                      className={inputClass}
                    />
                  </label>
                  <label className='flex flex-col gap-1.5'>
                    <span className='text-[10px] uppercase tracking-widest'>Service</span>
                    <select
                      required
                      value={service}
                      onChange={(e) => setService(e.target.value)}
                      className={`${inputClass} cursor-pointer [&>option]:text-neutral-800`}
                    >
                      <option value='' disabled>
                        Choose a service
                      </option>
                      {SERVICE_OPTIONS.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
                <label className='flex flex-col gap-1.5'>
                  <span className='text-[10px] uppercase tracking-widest'>Message</span>
                  <textarea
                    required
                    minLength={10}
                    maxLength={4000}
                    rows={4}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder='Describe your idea, goals, and timeline...'
                    className={`${inputClass} resize-none`}
                  />
                </label>
                {opened && (
                  <p className='text-xs text-neutral-700'>Opening your email app — the message is pre-filled, just hit send.</p>
                )}
                <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-2'>
                  <button
                    type='submit'
                    className='text-xl px-6 py-3 border border-neutral-500 hover:bg-neutral-700 hover:text-white hover:border-neutral-700 transition-colors'
                  >
                    Let&apos;s Talk <span>&gt;</span>
                  </button>
                  <div className='text-end text-xs'>
                    We Are Based
                    <div className='text-sm font-bold tracking-widest text-neutral-800'>IN MAJALENGKA</div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
